var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5007 6.66406C17.5007 5.28335 16.3814 4.16406 15.0007 4.16406H8.33398C6.95328 4.16406 5.83398 5.28335 5.83398 6.66406V16.6641C5.83398 18.0448 6.95328 19.1641 8.33398 19.1641H15.0007C16.3814 19.1641 17.5007 18.0448 17.5007 16.6641V6.66406ZM15.834 6.66406C15.834 6.20383 15.4609 5.83073 15.0007 5.83073H8.33398C7.87375 5.83073 7.50065 6.20383 7.50065 6.66406V16.6641C7.50065 17.1243 7.87375 17.4974 8.33398 17.4974H15.0007C15.4609 17.4974 15.834 17.1243 15.834 16.6641V6.66406Z",
    fill: "#D4D4D4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 2.5026H13.3333C13.7936 2.5026 14.1667 2.1295 14.1667 1.66927C14.1667 1.20904 13.7936 0.835938 13.3333 0.835938H5C3.61929 0.835938 2.5 1.95523 2.5 3.33594V15.0026C2.5 15.4629 2.8731 15.8359 3.33333 15.8359C3.79357 15.8359 4.16667 15.4629 4.16667 15.0026V3.33594C4.16667 2.8757 4.53977 2.5026 5 2.5026Z",
    fill: "#D4D4D4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/Copy.a6edcaaefa4ceac2b977b59962520bde.svg";
export { ForwardRef as ReactComponent };